<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">New Banner</h1>
    </div>

    <form class="form" @submit.prevent="handleSubmit">
      <img v-if="file !== ''" src="" alt="" />
      <div class="form-group">
        <label>Name</label>
        <input
          v-model="banner.name"
          class="form-control"
          placeholder="Banner name ..."
        />
      </div>

      <div class="form-group">
        <label>Upload Image Link</label>
        <input
          type="file"
          id="file"
          ref="file"
          v-on:change="handleFileUpload"
          class="form-control"
        />
        <br />
        <progress max="100" :value.prop="uploadPercentage"></progress>
      </div>

      <input type="submit" class="btn btn-primary" />
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "banner_new",

  data() {
    return {
      banner: {
        name: ""
      },

      file: "",
      uploadPercentage: 0
    };
  },

  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },

    handleSubmit() {
      if (this.file !== "" && this.banner.name !== "") {
        this.storeBanner();
      } else {
        swal({
          title: "Try Again",
          text: "All fields are required.",
          icon: "error"
        });
      }
    },

    storeBanner() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/banners",
            {
              name: this.banner.name
            },
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (!res.data.success) {
              swal({
                text: res.data.message,
                icon: "warning",
                button: "OK"
              });
            } else {
              this.uploadBanner(res.data.banner_id);
              swal({
                text: "Successful",
                icon: "success",
                button: "OK"
              });

              this.banner.title = "";
            }
          });
      }
    },

    uploadBanner(id) {
      let token = localStorage.getItem("token");

      let formdata = new FormData();

      formdata.append("name", this.file);
      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post("/banners/" + id + "/upload", formdata, {
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this)
          })
          .then(res => {});
      }
    }
  },

  mounted() {}
};
</script>
